module.exports = __webpack_public_path__ + "static/media/teamIcon.49bd928f.svg";